module.exports = __webpack_public_path__ + "media/assets/pngs/welcomeCarousel3-940a1ef146f9816c687d5e31c386fd73.png";